import { TrendingUp } from 'lucide-react';
import { DashboardRecentActivityAPI } from '@/api/type';
import { useTranslation } from 'react-i18next';

interface RecentMembersListProps {
  members: DashboardRecentActivityAPI['data']['recent_referrals'];
}

export const RecentMembersList = ({ members }: RecentMembersListProps) => {
  const { t } = useTranslation();

  const formatCurrency = (value: string | null) => {
    if (!value || value === '0') return '0đ';
    return `${Number(value).toLocaleString('vi-VN')}đ`;
  };

  return (
    <div className="!bg-white dark:!bg-dark-card rounded-xl shadow-sm border border-gray-200 dark:border-dark-border">
      <div className="p-4 sm:p-5 border-b border-gray-200 dark:border-dark-border">
        <h2 className="text-lg sm:text-xl font-bold !text-gray-900 dark:!text-white !mb-0">
          {t('dashboard.recent_referrals')}
        </h2>
      </div>

      <div className="p-4 sm:p-5">
        <div className="space-y-2">
          {members.length === 0 && (
            <p className="text-center !text-gray-500 dark:!text-dark-text-secondary italic !mb-0">
              {t('dashboard.no_referrals')}
            </p>
          )}
          {members.map((member) => (
            <div
              key={member.referee_id}
              className="flex items-center justify-between p-3 rounded-md !bg-gray-50 dark:!bg-dark-card-elevated hover:!bg-gray-100 dark:hover:!bg-dark-border transition-colors border border-gray-100 dark:border-dark-border"
            >
              <div className="flex items-center space-x-3">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full !bg-primary flex items-center justify-center text-white font-bold text-sm sm:text-base flex-shrink-0">
                  {member.user_info.avatar ? (
                    <img
                      src={member.user_info.avatar}
                      alt=""
                      className="w-full h-full rounded-full object-cover"
                    />
                  ) : (
                    member.user_info.fullname.charAt(0)
                  )}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold !text-gray-900 dark:!text-white !mb-0 truncate">
                    {member.user_info.fullname}
                  </p>
                  <p className="text-xs !text-gray-500 dark:!text-dark-text-secondary !mb-0">
                    {member.registered_at}
                  </p>
                </div>
              </div>
              <div className="text-right flex-shrink-0 !ml-2">
                <p className="text-sm sm:text-base font-bold !text-gray-900 dark:!text-white !mb-0">
                  {member.package_name || 'N/A'}
                </p>
                <div className="flex items-center justify-end space-x-1 !mt-1">
                  <TrendingUp className="w-3 h-3 !text-success" />
                  <p className="text-xs !text-gray-500 dark:!text-dark-text-secondary !mb-0">
                    {member.status}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
